import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import SD_DATA from 'sd-data'
import SD_AD from 'sd-ad'
import Utils from './utils'

Vue.prototype.$Utils = Utils
Vue.SD_DATA = Vue.$SD_DATA = Vue.prototype.$SD_DATA = SD_DATA

const sdDataOption = {
  biz: 'cf'
}
Vue.use(SD_DATA.vueRouterPlugin, {
  pageExt: [
    {
      ext: 'project_id_luban',
      type: 'function',
      key: function() { return 'fs8awfncn6an'}
    }
  ]
})
Vue.SD_DATA.init(sdDataOption)
Vue.SD_DATA.autoTrack()

Vue.use(SD_AD, {})

Vue.config.productionTip = false
Vue.use(window['common-text'].default)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
